// @ts-nocheck
import { FormulaHelpers, Types, FormulaError } from 'fast-formula-parser';
import { _isArray } from './common';
const H = FormulaHelpers;

// Special
export const Index = (context, ranges, rowNum, colNum, areaNum) => {
  // retrieve values
  rowNum = context.utils.extractRefValue(rowNum);
  rowNum = { value: rowNum.val, isArray: rowNum.isArray };
  rowNum = H.accept(rowNum, Types.NUMBER);
  rowNum = Math.trunc(rowNum);

  if (colNum == null) {
    colNum = 1;
  } else {
    colNum = context.utils.extractRefValue(colNum);
    colNum = { value: colNum.val, isArray: colNum.isArray };
    colNum = H.accept(colNum, Types.NUMBER, 1);
    colNum = Math.trunc(colNum);
  }

  if (areaNum == null) {
    areaNum = 1;
  } else {
    areaNum = context.utils.extractRefValue(areaNum);
    areaNum = { value: areaNum.val, isArray: areaNum.isArray };
    areaNum = H.accept(areaNum, Types.NUMBER, 1);
    areaNum = Math.trunc(areaNum);
  }

  // get the range area that we want to index
  // ranges can be cell ref, range ref or array constant
  let range = ranges;
  // console.log("ranges", ranges, typeof ranges, rowNum, colNum)
  // many ranges (Reference form)
  if (ranges instanceof Collection) {
    range = ranges.refs[areaNum - 1];
  } else if (areaNum > 1) {
    throw FormulaError.REF;
  }

  if (rowNum === 0 && colNum === 0) {
    return range;
  }

  // query the whole column
  if (rowNum === 0) {
    if (H.isRangeRef(range)) {
      if (range.ref.to.col - range.ref.from.col < colNum - 1)
        throw FormulaError.REF;
      range.ref.from.col += colNum - 1;
      range.ref.to.col = range.ref.from.col;
      return range;
    } else if (Array.isArray(range)) {
      const res = [];
      range.forEach((row) => res.push([row[colNum - 1]]));
      return res;
    }
  }
  // query the whole row
  if (colNum === 0) {
    if (H.isRangeRef(range)) {
      if (range.ref.to.row - range.ref.from.row < rowNum - 1)
        throw FormulaError.REF;
      range.ref.from.row += rowNum - 1;
      range.ref.to.row = range.ref.from.row;
      return range;
    } else if (Array.isArray(range)) {
      return range[colNum - 1];
    }
  }
  // query single cell
  if (rowNum !== 0 && colNum !== 0) {
    // range reference
    if (H.isRangeRef(range)) {
      range = range.ref;
      if (
        range.to.row - range.from.row < rowNum - 1 ||
        range.to.col - range.from.col < colNum - 1
      )
        throw FormulaError.REF;
      // console.log("{ ref: { row: range.from.row + rowNum - 1, col: range.from.col + colNum - 1 }", range.from.row + rowNum - 1, range.from.col + colNum - 1)
      return {
        ref: {
          row: range.from.row + rowNum - 1,
          col: range.from.col + colNum - 1,
          sheet: range.sheet,
        },
      };
    }
    // cell reference
    else if (H.isCellRef(range)) {
      range = range.ref;
      if (rowNum > 1 || colNum > 1) throw FormulaError.REF;
      return {
        ref: {
          row: range.row + rowNum - 1,
          col: range.col + colNum - 1,
          sheet: range.sheet,
        },
      };
    }
    // array constant
    else if (Array.isArray(range)) {
      if (range.length < rowNum || range[0].length < colNum)
        throw FormulaError.REF;
      return range[rowNum - 1][colNum - 1];
    }
  }
};

class Collection {
  constructor(data, refs) {
    if (data == null && refs == null) {
      this._data = [];
      this._refs = [];
    } else {
      if (data.length !== refs.length)
        throw Error('Collection: data length should match references length.');
      this._data = data;
      this._refs = refs;
    }
  }

  get data() {
    return this._data;
  }

  get refs() {
    return this._refs;
  }

  get length() {
    return this._data.length;
  }

  /**
   * Add data and references to this collection.
   * @param {{}} obj - data
   * @param {{}} ref - reference
   */
  add(obj, ref) {
    this._data.push(obj);
    this._refs.push(ref);
  }
}
